import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/DbosTransactPage.head';
import { DbosTransactPage } from '@pages/DbosTransactPage';

export const Route = createFileRoute('/dbos-transact')({
  component: DbosTransactPage,
  head: () => head,
});
